import DomU, {$} from './DomU';
import EventEmitter from './EventEmitter';
import _ from '../vendors/_';
import Browsers from '../constants/Browsers';
import {Point, WinU_state} from '../../@types/shared';
import Tween from './Tween';
import Ticker from './Ticker';
import u_getPoint from '../utils/u_getPoint';
import u_subPoint from '../utils/u_subPoint';
import Timeout = NodeJS.Timeout;

const DRAG_DECREASE: number = 0.5;//dragの加速度減衰率
const DRAG_DIR_MIN: number = 30;//dragEnd時のdirを判定する際に何px動いたら放り投げとみなすか

export default new class WinU extends EventEmitter {
  public e = {
    load: 'load',
    resize: 'resize',
    resizeAny: 'resizeAny',
    directionChange: 'directionChange',
    break: 'break',
    scroll: 'scroll',
    update: 'update',
    mouseMove: 'mouseMove',
    mouseDown: 'mouseDown',
    mouseUp: 'mouseUp',
    touchStart: 'touchStart',
    touchEnd: 'touchEnd',
    dragStart: 'dragStart',
    dragMove: 'dragMove',
    dragEnd: 'dragEnd',
    focus: 'focus',
    key: 'key',
    keyUp: 'keyUp',
  };
  public direction = {
    portrait: 'portrait',
    landscape: 'landscape',
  };

  private $window: DomU;
  private $html: DomU;
  private $body: DomU;
  private $landscape: DomU;
  private $outer: DomU;
  private $inner: DomU;
  private _$mq: { pc: DomU, tab: DomU, sp: DomU };
  private _$fixed: DomU[];
  private _scrollTarget: Element;
  private _state: WinU_state = {
    dragDiff: {dx: 0, dy: 0, ax: 0, ay: 0},
    modalOpened: false,
    modalAnimating: false,
    focusing: true,
    keyPressing: {},
  };
  private _tw: Tween;
  private _modalDelayId: Timeout;
  private _memoriedScrollTop: number;
  private _bindedCalcBodyHeight: Function;
  private _bodyHeight: number;
  private _$fixedInner: DomU[];
  private _$fixedCenter: DomU[];
  private $scrollChecker: DomU;
  private $scrollCheckerInner: DomU;
  private $edge: DomU;

  setup() {
    this._scrollTarget = (document.scrollingElement || document.documentElement);
    this.$window = $(window);
    this.$body = $(document.body);
    this.$html = $('html');
    this.$edge = $(`<div class="js_winu_edge"></div>`).appendTo(this.$body);
    this.$landscape = $(`<div class="js_winu_landscape"></div>`).appendTo(this.$body);
    this._$mq = {
      pc: $(`<div class="js_winu_mq -pc"></div>`).appendTo(this.$body),
      tab: $(`<div class="js_winu_mq -tab"></div>`).appendTo(this.$body),
      sp: $(`<div class="js_winu_mq -sp"></div>`).appendTo(this.$body),
    };
    this._$fixed = $.find$('.js_winu_fixed');
    this._$fixedInner = $.find$('.js_winu_fixedInner');
    this._$fixedCenter = $.find$('.js_winu_fixedCenter');
    this.$outer = $(`<div class="js_winu_outer"></div>`).appendTo(this.$body);
    this.$inner = $(`<div class="js_winu_inner"></div>`).appendTo(this.$body);
    this.$scrollChecker = $(`<div class="js_winu_scrollChecker"></div>`).appendTo(this.$body);
    this.$scrollCheckerInner = $(`<div class="js_winu_scrollCheckerInner">bar</div>`).appendTo(this.$scrollChecker);
    setTimeout(this._loadHdl.bind(this), 5000);
    this.$window
      .on('load', this._loadHdl.bind(this), {passive: true})
      .on('scroll', this._scrollHdl.bind(this), {passive: true})
      .on('resize', this._resizeHdl.bind(this, false), {passive: true})
      .on('focus', this._focusHdl.bind(this, false), {passive: true})
      .on('blur', this._blurHdl.bind(this, false), {passive: true});
    if (Browsers.desktop) {
      this.$window
        .on('mousedown', this._mouseDownHdl.bind(this), {passive: false})
        .on('mousemove', this._mouseMoveHdl.bind(this), {passive: false})
        .on('mouseup', this._mouseUpHdl.bind(this), {passive: false})
        .on('keydown', this._keyDownHdl.bind(this), {passive: false})
        .on('keyup', this._keyUpHdl.bind(this), {passive: false});
    } else {
      this.$window
        .on('touchstart', this._touchStartHdl.bind(this), {passive: false})
        .on('touchmove', this._touchMoveHdl.bind(this), {passive: false})
        .on('touchend', this._touchEndHdl.bind(this), {passive: false});
    }
    Ticker.on(Ticker.e.update, this._updateHdl.bind(this));
    this._calcScrollBarWidth();
    this._offsetScrollbar();
    this._scrollHdl();
    this._resizeHdl(false);
    this._updateHdl();
  }

  get state(): WinU_state {
    return this._state;
  }

  get bodyHeight(): number {
    return this._bodyHeight;
  }

  bind(isBind: boolean, e: string, fn: Function): this {
    if (isBind) return this.on(e, fn);
    else return this.off(e, fn);
  }

  on(e: string, fn: Function): this {
    if (e === this.e.load && this._state.loaded) {
      fn();//すでにonloadだった場合にちゃんと呼ばれるように
      return this;
    }
    return super.on(e, fn);
  }

  scrollTo(top, duration = 0) {
    this._tw && this._tw.stop();
    if (duration === 0) {
      this._scrollTarget.scrollTop = top;
      return;
    }
    this._tw = this._tw || new Tween();
    this._tw.it({
      start: this._state.scrollTop,
      end: top,
      duration: duration,
      easing: 'easeInOutQuart',
      onProgress: (v) => {
        this._scrollTarget.scrollTop = v;
      }
    });
  }

  switchModal(opened: boolean, delay: number = 0) {
    clearTimeout(this._modalDelayId);
    if (delay === 0) return this._doSwitchModal(opened);
    this._modalDelayId = setTimeout(this._doSwitchModal.bind(this, opened), delay);
  }

  triggerResize() {
    this._resizeHdl(true);
  }

  isKeyPressing(keyCode: number): boolean {
    return !!this._state.keyPressing[keyCode];
  }

  _calcScrollBarWidth() {
    if (Browsers.touch) {
      this._state.scrollBarWidth = 0;
    } else {
      this._state.scrollBarWidth = this.$scrollChecker.width() - this.$scrollCheckerInner.width();
    }
    this.$scrollChecker.remove();
  }

  _offsetScrollbar() {
    if (!this._state.scrollBarWidth) return;

    //スクロールバー分オフセット
    $.find$('.js_winu_rightOffset').forEach(($el) => {
      $el.css('margin-right', this._state.scrollBarWidth);
    });
    $.find$('.js_winu_rightOffsetMinus').forEach(($el) => {
      $el.css('margin-right', -this._state.scrollBarWidth);
    });
  }

  _doSwitchModal(opened: boolean) {
    //モーダルの挙動が実行中フラグ（モーダル表示前後にスクロール系判定しないように）
    this._state.modalAnimating = true;
    this._modalDelayId = setTimeout(() => {
      this._state.modalAnimating = false;
      if(opened && Browsers.safari) {//PC safariでスクロールできてしまう問題
        this.$html.css('overflow', 'hidden').css('height', '100%');
        this.$body.css('overflow', 'hidden').css('height', '100%');
      }
    }, 200);

    if (this._state.modalOpened === opened) return;
    this._state.modalOpened = opened;
    if (opened) {
      if (this._state.scrollBarWidth) this.$body.css('margin-right', this._state.scrollBarWidth);//css側でbodyにoverflow-y: hiddenなら不要
      if (Browsers.touch) {
        this.$html.css('overflow', 'hidden').css('height', '100%');
        this.$body.css('overflow', 'hidden').css('height', '100%');
      } else {
        this.$html.css('overflow-y', 'hidden');
      }
      this._memoriedScrollTop = this._state.scrollTop;
      this.$body.scrollTop(this._memoriedScrollTop);
      this._offsetFixedElements();
    } else {
      if (this._state.scrollBarWidth) this.$body.css('margin-right', '');
      this.$html.css('overflow', '').css('overflow-y', '').css('height', '');
      this.$body.css('overflow', '').css('overflow-y', '').css('height', '');
      this.$body.scrollTop(0);
      this.scrollTo(this._memoriedScrollTop);
      this._offsetFixedElements();
    }
  }

  _offsetFixedElements() {
    if (!this._state.scrollBarWidth) return;
    this._$fixed.forEach(($el) => {
      $el.css('margin-right', this._state.modalOpened ? this._state.scrollBarWidth : '');
    });
    if (this._state.modalOpened) {
      this._$fixedInner.forEach(($el) => {
        $el.css('margin-right', this._state.scrollBarWidth);
      });
      // this._$fixedCenter.forEach(($el) => {
      //
      //   $el.css('margin-left', this._state.scrollBarWidth);
      // });
    } else {
      setTimeout(() => {
        this._$fixedInner.forEach(($el) => {
          $el.css('margin-right', '');
        });
      }, 500);
    }
  }

  _loadHdl() {
    if (this._state.loaded) return;
    this._state.loaded = true;
    this.emit(this.e.load);

    this._resizeHdl(true);

    //一定時間ごとにbodyの高さ図る
    this._bindedCalcBodyHeight = this._calcBodyHeight.bind(this);
    setTimeout(this._bindedCalcBodyHeight, 100);
  }

  _scrollHdl() {
    if (this._state.modalAnimating || this._state.modalOpened) return;
    const scrollTop = this._scrollTarget.scrollTop;
    const scrollLeft = this._scrollTarget.scrollLeft;
    const changed = {
      top: this._state.scrollTop !== scrollTop,
      left: this._state.scrollLeft !== scrollLeft,
    };
    this._state.scrollTop = scrollTop;
    this._state.scrollLeft = scrollLeft;
    if (changed.left) {
      this._$fixed.forEach(($el) => {
        $el.transform({x: -this._state.scrollLeft});
      });
    }
    this.emit(this.e.scroll);
  }

  _resizeHdl(forced: boolean) {
    const oldWidth: number = this._state.width;
    const oldHeight: number = this._state.height;
    this._state.width = this.$outer.width();
    this._state.height = this.$outer.height();

    //touchデバイスでは、innerWidth/innerHeightは最小値を記憶しておく（端末の向きが変わったらリセット）
    const direction = this.$landscape.css('display').toLowerCase() === 'block' ? this.direction.landscape : this.direction.portrait;
    const directionChanged = direction !== this._state.direction;
    if (directionChanged) {
      this._state.direction = direction;
      if (Browsers.touch) {
        this._state.innerWidth = undefined;
        this._state.innerHeight = undefined;
      }
    }
    const innerWidth: number = this.$inner.width();
    const innerHeight: number = Math.min(this.$inner.height(), window.innerHeight);
    if (Browsers.touch) {
      this._state.innerWidth = this._state.innerWidth === undefined ? innerWidth : Math.min(this._state.innerWidth, innerWidth);
      this._state.innerHeight = this._state.innerHeight === undefined ? innerHeight : Math.min(this._state.innerHeight, innerHeight);
    } else {
      this._state.innerWidth = this.$inner.width();
      this._state.innerHeight = this.$inner.height();
    }

    this._state.fullWidth = Browsers.touch ? this._state.width : this._state.innerWidth;
    this._state.fullHeight = this._state.height;

    this._bodyHeight = document.body.scrollHeight;

    //スマホで全画面になったかどうか
    if(Browsers.touch) {
      const isSpFull = innerHeight > this._state.innerHeight;
      this.$html.toggleClass('html_spFull', isSpFull);
    }

    //mq
    const mq = _.findKey(this._$mq, ($el) => {
      return $el.css('display').toLowerCase() === 'block';
    });
    if (this._state.mq !== mq) {
      this._state.mq = mq;
      this.emit(this.e.break);
    }

    //emit
    this.emit(this.e.resizeAny);
    if (!forced && oldWidth === this._state.width && oldHeight === this._state.height) return;
    this.emit(this.e.resize);
    if (directionChanged) this.emit(this.e.directionChange);
  }

  _calcBodyHeight() {
    const bodyHeight = document.body.scrollHeight;
    if (this._bodyHeight !== bodyHeight && !this._state.modalOpened) {
      const oldBodyHeight: number = this._bodyHeight;
      this._bodyHeight = bodyHeight;
      if (oldBodyHeight !== undefined) this._resizeHdl(true);//初回は無視
    }

    //古いiOSでfullになったときにresizeが走らない対応
    if(Browsers.touch) {
      const innerHeight: number = Math.min(this.$inner.height(), window.innerHeight);
      if(this._state.innerHeight !== innerHeight) {
        this._resizeHdl(true);
      }
    }


    setTimeout(this._bindedCalcBodyHeight, 1000);
  }

  _updateHdl() {
    this._state.dragDiff.ax *= DRAG_DECREASE;
    this._state.dragDiff.ay *= DRAG_DECREASE;
    this.emit(this.e.update);
  }

  _mouseDownHdl(e: Event) {
    if (this._state.pressing) return;
    this._state.pressing = true;
    this._dragStart(e);
    this.emit(this.e.mouseDown);
  }

  _mouseMoveHdl(e: Event) {
    this._state.cursorPoint = u_getPoint(e);
    this.emit(this.e.mouseMove, e);
    if (!this._state.pressing) return;
    this._dragMove(e);
    this.emit(this.e.mouseUp);
  }

  _mouseUpHdl(e: Event) {
    if (!this._state.pressing) return;
    this._state.pressing = false;
    this._dragEnd(e);
  }

  _touchStartHdl(e: Event) {
    if (this._state.touching) return;
    this._state.touching = true;
    this._state.touchPoint = u_getPoint(e);
    this.emit(this.e.touchStart, e);
    this._dragStart(e);
  }

  _touchMoveHdl(e: Event) {
    this._state.touchPoint = u_getPoint(e);
    this._dragMove(e);
  }

  _touchEndHdl(e: Event) {
    if (!this._state.touching) return;
    this._state.touching = false;
    this.emit(this.e.touchEnd, e);
    this._dragEnd(e);
  }

  _dragStart(e: Event) {
    this._state.dragStartPoint = u_getPoint(e);
    this._state.dragDiff = {dx: 0, dy: 0, ax: 0, ay: 0, dirX: 0, dirY: 0, startTime: Ticker.state.currentTime};
    if (!this._state.dragging) {
      this._state.dragging = true;
      this.emit(this.e.dragStart, e);
    }
  }

  _dragMove(e: Event) {
    const diff: Point = u_subPoint(u_getPoint(e), this._state.dragStartPoint);
    this._state.dragDiff.ax += diff.x - this._state.dragDiff.dx;
    this._state.dragDiff.ay += diff.y - this._state.dragDiff.dy;
    this._state.dragDiff.dx = diff.x;
    this._state.dragDiff.dy = diff.y;
    // if (!this._state.dragging) {
    //   this._state.dragging = true;
    //   this.emit(this.e.dragStart, e);
    // }
    this.emit(this.e.dragMove, e);
  }

  _dragEnd(e: Event) {
    if (!this._state.dragging) return;
    this._state.dragDiff.elapsedTime = Ticker.state.currentTime - this._state.dragDiff.startTime;
    if (Math.abs(this._state.dragDiff.dx) > DRAG_DIR_MIN) {
      if (this._state.dragDiff.dx < 0 && this._state.dragDiff.ax < 0) this._state.dragDiff.dirX = -1;
      else if (this._state.dragDiff.dx > 0 && this._state.dragDiff.ax > 0) this._state.dragDiff.dirX = 1;
    }
    if (Math.abs(this._state.dragDiff.dy) > DRAG_DIR_MIN) {
      if (this._state.dragDiff.dy < 0 && this._state.dragDiff.ay < 0) this._state.dragDiff.dirY = -1;
      else if (this._state.dragDiff.dy > 0 && this._state.dragDiff.ay > 0) this._state.dragDiff.dirY = 1;
    }
    this._state.dragging = false;
    this.emit(this.e.dragEnd, e);
  }

  _focusHdl() {
    this._state.focusing = true;
    this.emit(this.e.focus);
  }

  _blurHdl() {
    this._state.focusing = false;
    this._state.keyPressing = {};//keyを全部話したことにする
    this.emit(this.e.focus);
  }

  _keyDownHdl(e: KeyboardEvent) {
    this._state.keyPressing[e.keyCode] = true;
    this.emit(this.e.key);
  }

  _keyUpHdl(e: KeyboardEvent) {
    delete this._state.keyPressing[e.keyCode];
    this.emit(this.e.key);
    this.emit(this.e.keyUp, e);
  }
}();
